const actionTypes = {
  LOAD_DATA: 'LOAD_DATA',

  UPDATE_CART: 'UPDATE_CART',
}

export default actionTypes;